export const IS_EXACT_MATCH = 'isExactMatch';
export const IS_REGEX = 'isRegex';
